import { call, take } from 'redux-saga/effects';
import axios          from 'axios';
import { DateTime }   from 'luxon';

const now = DateTime.local();
const weekFromNow = now.plus({ days: 7 }).toFormat('yyyy-LL-dd');


const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/setWhatsappReminder.php';
 
function* setWhatsappReminder(): Generator<any,any,any> {
  while(true) {
    try {

        const input = yield take('SET_WHATSAPP_REMINDER_SAGA');
        
        const { userEmail, disable } = input.payload;

        const obj = {
            userEmail:   userEmail,
            newReminder: disable ? 'disable' : weekFromNow
        }

        if (process.env.NODE_ENV === 'development') {

           // console.log('obj : ',obj)
  
        }
        else {

            const res = yield call( axios.post, endpoint, obj);        
            console.log('res : ',res)
            
        }
       

    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default setWhatsappReminder;






